import NeptuneElement from '../../NeptuneElement.js';

class Progress extends NeptuneElement {

    static PROGRESS_BAR_TYPES = [
        'default', 'success', 'warning', 'error', 'danger'
    ];

    static PROGRESS_THICKNESSES = ['small', 'medium', 'large'];

    static get PROGRESS_TYPES() {
        return this.PROGRESS_BAR_TYPES;
    }

    templateMarkup = `
        <div>
            <label></label>
            <progress></progress>
            <span></span>
        </div>
    `;
    componentCssUrl = '/src/components/core/progress/progress.css';

    constructor() {
        super();
    }

    async connectedCallback() {
        await super.connectedCallback();
        this.validateRequiredProperties(['value', 'max', 'type', 'thickness']);
        this.handleAccessibilityAttributes();
        this.processInitialAttributesAfterRender(Progress.observedAttributes);
    }

    static get observedAttributes() {
        return ['value', 'max', 'type', 'thickness', 'label', 'supporting-text'];
    }

    attributeChangedCallback(name, oldValue, newValue) {
        if (!this.isRendered) {
            return;
        }
        this.processAttribute(name, oldValue, newValue);
    }

    processAttribute(name, oldValue, newValue) {
        const progressElement = this.shadowRoot.querySelector('progress');
        if (!progressElement) {
            return;
        }

        switch (name) {
            case 'value':
            case 'max': {
                const value = parseFloat(this.getAttribute('value'));
                const max = parseFloat(this.getAttribute('max'));

                if (!isFinite(max) || max <= 0) {
                    throw new Error(`Invalid max "${max}" for <neptune-progress>. Max must be a positive number.`);
                }
                if (!isFinite(value) || value < 0 || value > max) {
                    throw new Error(`Invalid value "${value}" for <neptune-progress>. The valid range is 0 to ${max}.`);
                }

                progressElement.setAttribute('max', max);
                progressElement.setAttribute('value', value);
                break;
            }
            case 'type': {
                this.validatePropertyValue(name, newValue, Progress.PROGRESS_BAR_TYPES);
                progressElement.setAttribute('data-type', newValue.trim().toLowerCase());
                break;
            }
            case 'thickness': {
                this.validatePropertyValue(name, newValue, Progress.PROGRESS_THICKNESSES);
                progressElement.setAttribute('data-thickness', newValue.trim().toLowerCase());
                break;
            }
            case 'label': {
                this.setLabel(newValue);
                break;
            }
            case 'supporting-text': {
                this.setSupportingText(newValue);
                break;
            }
            default: {
                break;
            }
        }
    }

    handleAccessibilityAttributes() {
        const progressElement = this.shadowRoot.querySelector('progress');
        const labelElement = this.shadowRoot.querySelector('label');
        const supportingTextElement = this.shadowRoot.querySelector('span');

        if (!progressElement || !labelElement || !supportingTextElement) {
            return;
        }

        const idBase = Math.random().toString(36).substr(2, 9);
        labelElement.id = `neptune-progress-label-${idBase}`;
        supportingTextElement.id = `neptune-progress-support-${idBase}`;

        progressElement.setAttribute('aria-labelledby', labelElement.id);
        progressElement.setAttribute('aria-describedby', supportingTextElement.id);
    }

    setLabel(labelText) {
        const labelElement = this.shadowRoot.querySelector('label');
        if (!labelElement) {
            return;
        }

        labelElement.textContent = (labelText || '').trim();
    }

    setSupportingText(supportingText) {
        const supportingTextElement = this.shadowRoot.querySelector('span');
        if (!supportingTextElement) {
            return;
        }

        supportingTextElement.textContent = (supportingText || '').trim();
    }

}

customElements.define('neptune-progress', Progress);
export default Progress;